/**
 * @description Integrates a sticky footer and adjusts other bottom elements accordingly
 * @param { object } [param]
 * @param { number }  [param.offsetBottom]
 * @param { string } [param.stickyFooterSelector]
 * @param { string } [param.targetSelector]
 * @returns {{computed: {isNotPrint(): *}, beforeDestroy(): void, mounted(): void}|boolean}
 */

/**
 * @function
 * @param {HTMLElement | null} element
 * @returns {boolean}
 */
const isHidden = element => !element || (element.offsetWidth === 0 && element.offsetHeight === 0);

export default ({ offsetBottom = 15, stickyFooterSelector, targetSelector } = {}) => {
    return {
        computed: {
            isNotPrint() {
                return !this.$root.isPrint;
            }
        },
        mounted() {
            this.$nextTick(() => {
                //nextTick to avoid subsequent framework class updates
                if (this.isNotPrint) {
                    let footer;
                    if (stickyFooterSelector) {
                        footer = document.querySelector(stickyFooterSelector);
                        if (!footer) {
                            return;
                        }
                    } else {
                        footer = this.$getSafe(this, '$refs.footer.$el') || document.getElementsByTagName('footer')[0];
                    }

                    if (footer) {
                        if (isHidden(footer)) {
                            return;
                        }

                        let target;
                        if (targetSelector) {
                            target = document.querySelector(targetSelector);
                            if (!target) {
                                return;
                            }
                        } else {
                            target = document.getElementById('animod');
                        }

                        const style = document.createElement('style');
                        style.setAttribute('type', 'text/css');
                        document.head.appendChild(style);

                        const floatingBottom = document.getElementById('floatingBottom');
                        const randomHash = Math.random().toString(36).slice(2);
                        const targetClassName = `sticky-footer-padding-${randomHash}`;
                        const floatingClassName = `sticky-footer-bottom-${randomHash}`;

                        if (
                            getComputedStyle(footer).position === 'fixed' ||
                            getComputedStyle(footer).position === 'absolute'
                        ) {
                            // sticky elements are respected by the siblings, no padding required
                            // fixed elements are in their own flow, padding is required
                            style.sheet.insertRule(
                                `.${targetClassName} { padding-bottom: ${
                                    footer.clientHeight + offsetBottom
                                }px !important; }`
                            );
                            target.classList.add(targetClassName);
                        }

                        if (floatingBottom) {
                            style.sheet.insertRule(
                                `.${floatingClassName} { bottom: ${footer.clientHeight}px !important; }`
                            );
                            floatingBottom.classList.add(floatingClassName);
                        }

                        this.$once('hook:beforeDestroy', () => {
                            if (floatingBottom) {
                                floatingBottom.classList.remove(floatingClassName);
                            }

                            if (target) {
                                target.classList.remove(targetClassName);
                            }

                            style.remove();
                        });
                    }
                }
            });
        }
    };
};
